import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { CreateCandidateResponse, PicturePayload } from '../../models/candidate.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../services/loader.service';
import { CandidateRegisterService } from '../../services/candidate-register.service';
import { ErrorHandlingService } from 'src/app/services/error-handling.service';
import { resetStorage } from 'src/app/shared-functions';

export abstract class AbstractCandidateRegister {

  candidateRegisterForm: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    email: [
      '',
      [
        Validators.required,
        Validators.pattern(
          '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,15}$'
        ),
      ],
    ],
    networks: [null, [Validators.required]],
    phone: [
      '',
      [
        Validators.required,
        Validators.pattern('^[0-9]*$'),
      ],
    ],
    acceptTermsAndConditions: ['', [Validators.requiredTrue]],
    picture: ['', [Validators.required]],
    location: [null, [Validators.required]],
    gender: ['', [Validators.required]]
  });

  companyGuid: string;
  termsAndConditions: string;
  candidateData: CreateCandidateResponse;

  protected constructor(
    protected fb: FormBuilder,
    protected router: Router,
    protected toastr: ToastrService,
    protected loaderService: LoaderService,
    protected translateService: TranslateService,
    protected candidateRegisterService: CandidateRegisterService,
    protected errorHandlingService: ErrorHandlingService
  ) { }

  abstract createApplication(picture: PicturePayload): void;

  alreadyAppliedForJob(): void {
    resetStorage();
    this.router.navigate(['/']);
    this.toastr.error(
      this.translateService.instant('ERRORS.ALREADY_FINISHED_APP')
    );
  }
}
